var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTranslate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-761 -180)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    transform: "translate(761 180)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-70.185 37)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(834.115 148.093)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.462,
    cy: 5.462,
    r: 5.462,
    transform: "translate(0 0)",
    fill: "#26B963"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.462,1A4.462,4.462,0,1,0,9.924,5.462,4.467,4.467,0,0,0,5.462,1m0-1A5.462,5.462,0,1,1,0,5.462,5.462,5.462,0,0,1,5.462,0Z",
    transform: "translate(0 0)",
    fill: "#26B963"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.74 3.277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.462,10.425a4.962,4.962,0,1,1,4.962-4.962A4.968,4.968,0,0,1,5.462,10.425Z",
    fill: "#26B963"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.462,1A4.462,4.462,0,1,0,9.925,5.462,4.467,4.467,0,0,0,5.462,1m0-1A5.462,5.462,0,1,1,0,5.462,5.462,5.462,0,0,1,5.462,0Z",
    fill: "#26B963"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(832.76 147)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.228,109.678a6.381,6.381,0,1,1-6.213,7.841,6.381,6.381,0,1,1,3.338-7.159,6.353,6.353,0,0,1,2.875-.682ZM23.9,111.771l1.535-.886v.443a2.124,2.124,0,0,1,2.348,2.238,2.255,2.255,0,0,0-2.348-1.352v.443Zm4.261,2.526-1.535.886v-.443a2.124,2.124,0,0,1-2.348-2.238,2.255,2.255,0,0,0,2.348,1.352v-.443ZM22.869,110a5.034,5.034,0,0,1-1.385,3.307,3.353,3.353,0,0,0,2.014,1.017l-.177,1.015a4.358,4.358,0,0,1-2.644-1.389,4.569,4.569,0,0,1-1.709.612l-.177-1.014a3.587,3.587,0,0,0,1.283-.436,5.431,5.431,0,0,1-.664-2.638l1.027-.025a4.483,4.483,0,0,0,.448,2A4.066,4.066,0,0,0,21.842,110H18.677v-1.04h1.836v-.644H21.77v.644h1.836V110Zm6.712,2.719h1.143l2.725,6.692H32.14l-.737-1.932H28.94l-.691,1.932H27.011ZM29.3,116.47h1.714c-.3-.782-.607-1.563-.873-2.356C29.921,114.914,29.6,115.693,29.3,116.47Z",
    transform: "translate(-14.76 -105.44)",
    fill: "#fff",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranslate);
export default __webpack_public_path__ + "static/media/translate.8759dd9eb51347d2301c634cfbe87f9f.svg";
export { ForwardRef as ReactComponent };